import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  secondaryText?: string;
  backLabel?: string;
  onBack?: () => void;
  actions?: ReactNode;
}

/**
 * Reusable page header — title, optional subtitle, back button, and action slot.
 */
export function PageHeader({ title, subtitle, secondaryText, backLabel, onBack, actions }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        {onBack && (
          <Button
            size="small"
            startIcon={<ArrowBackIcon fontSize="small" />}
            onClick={onBack}
            sx={{ mb: 0.5, ml: -0.5, color: 'text.secondary' }}
          >
            {backLabel ?? 'Back'}
          </Button>
        )}
        <Typography variant="h1" component="h1">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
        {secondaryText && (
          <Typography variant="body2" color="text.secondary">
            {secondaryText}
          </Typography>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
